import React from 'react';
import _ from 'lodash';
import MediaItem from './MediaItem.jsx';
import Loader from '../Loader.jsx';

export default class MediaList extends React.PureComponent {
  render() {
    const { mediaItems, sportParam, linkTemplate, showMoreText } = this.props;

    return (
      <section>
        { mediaItems.length ?
          _(mediaItems)
            .chunk(2)
            .map(chunkItems =>
              <div key={_.map(chunkItems, 'id').join('')} className="row">
                {
                  _.map(chunkItems, ({id, heading, images, recentPost}) =>
                    <MediaItem linkTemplate={linkTemplate}
                              key={id}
                              routeParams={[sportParam, id]}
                              heading={heading}
                              images={images}
                              post={recentPost}
                              linkText={`${showMoreText} ${heading}`}
                            />
                  )
                }
              </div>)
            .value()
          : <Loader />
        }
      </section>
    );
  }
}

MediaList.propTypes = {
  linkTemplate: React.PropTypes.string,
  showMoreText: React.PropTypes.string,
  sportParam: React.PropTypes.string,
  mediaItems: React.PropTypes.array,
};



// WEBPACK FOOTER //
// ./src/component/MediaPages/MediaList.jsx